import gql from 'graphql-tag';

import { SessionDataQueryRaw } from './SessionDataQueryRaw';

export const SessionDataQuery = gql`
	${SessionDataQueryRaw}
`;
